const DEFAULT_CONFIG = {
  allDaySlot: false,
  contextMenu: {
    items: [],
    render: null,
    onEvents: true,
    onCells: false,
  },
  eventEditor: {
    render: null,
  },
  dayHeaderAlign: 'center',
  dayMinWidth: 150,
  editable: true,
  events: [],
  eventResizableFromStart: true,
  firstDay: 1,
  selectable: true,
  header: {
    left: undefined,
    center: undefined,
    right: undefined,
  },
  height: '100%',
  initialView: 'timeGridScrollWeek',
  isLoading: false,
  scrollTime: '06:00:00',
  scrollTimeReset: false,
  slotDuration: '00:30:00',
  slotHeaderInterval: '01:00:00',
  slotEventOverlap: false,
  slotHeaderFormat: {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    omitZeroMinute: false,
    meridiem: 'uppercase',
  },
  slotMinHeight: 60,
  slotMinWidth: 60,
  timeZone: 'UTC',
  tooltip: 'on',

  // might have to move these later
  calendarContainerClass: '',
  isBroadcastClock: false,
  views: {},
};

export default DEFAULT_CONFIG;
